var lib_core      = require("lib-core");

var SettingsModel = function (data) {
    lib_core.Model.call(this);

    this.data = data;
    this.metaData = this.data.metaData();

    this.privateShadow = this.value('privateShadow', true);
    this.privateShadow(this.data.root.asset.private);

    this.nameShadow = this.shadow("nameShadow",
        function () {
            return this.metaData.name();
        },
        function (value) {
            return this.metaData.name(value);
        },
        [this.metaData.name]
    );

    this.summaryShadow = this.shadow("summaryShadow",
        function () {
            return this.metaData.summary();
        },
        function (value) {
            return this.metaData.summary(value);
        },
        [this.metaData.summary]
    );

    this.descriptionShadow = this.shadow("descriptionShadow",
        function () {
            return this.metaData.description();
        },
        function (value) {
            return this.metaData.description(value);
        },
        [this.metaData.description]
    );

    this.tagsShadow = this.shadow("tagsShadow",
        function () {
            var res = "";
            var j = 0;
            this.metaData.tags.forEach(function(i, tag) {
                if(j !== 0) res += ", ";
                res += tag;
                j += 1;
            });
            return res;
        },
        function (value) {
            var list = value.split(",");
            list = list.map(function (e) {return e.trim();});
            if(list.length === 1 && list[0] == "") {
                list.pop();
            }
            if(list.indexOf("") !== -1) return false;
            this.metaData.tags.removeAll();
            this.metaData.tags.addAll(list);
            return true;
        },
        [this.metaData.tags]
    );

    this.aliasShadow = this.shadow("aliasShadow",
        function () {
            return this.metaData.alias();
        },
        function (value) {
            return this.metaData.alias(value);
        },
        [this.metaData.alias]
    );
};
lib_core.inherit(SettingsModel, lib_core.Model);
SettingsModel.$class = 'SettingsModel';

module.exports = SettingsModel;
